/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Prop_EyebrowInputs */

const es_cap_prop_eyebrow = /** @type {(inputs: Cap_Prop_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceptar o rechazar, siempre tú`)
};

const gl_cap_prop_eyebrow = /** @type {(inputs: Cap_Prop_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceptar ou rexeitar, sempre ti`)
};

const en_cap_prop_eyebrow = /** @type {(inputs: Cap_Prop_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept or decline — always your call`)
};

/**
* | output |
* | --- |
* | "Accept or decline — always your call" |
*
* @param {Cap_Prop_EyebrowInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_prop_eyebrow = /** @type {((inputs?: Cap_Prop_EyebrowInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Prop_EyebrowInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_prop_eyebrow(inputs)
	if (locale === "en") return en_cap_prop_eyebrow(inputs)
	return es_cap_prop_eyebrow(inputs)
});